import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ParticipantService } from '../../../services/participant.service';
import { ToastrService } from 'ngx-toastr';
import { UserDataStoreService } from '../../../services/user-data-store.service';
import { ActivatedRoute, Route, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { RetailerConfigViewModel } from '../../../models/terminal-config-retailer-view-model';
import { CreateResult } from '../../../models/create-result';
import { TerminalConfigService } from '../../../services/terminal-config.service';
import { takeUntil } from 'rxjs/operators';
import { async } from '@angular/core/testing';
import { Subject, config } from 'rxjs';
import { Select2OptionData } from 'ng-select2';
import { StoreViewModel } from '../../../models/store-view-model';
import { ConfigSetViewModel } from '../../../models/config-set-view-model';
import { RolloutGroupViewModel } from '../../../models/rollout-group-view-model';
import { MerchantService } from '../../../services/merchant.service';
import { LaneProfilesViewModel } from '../../../models/lane-profiles-view-model';
import { AdditionalEsocketConfig } from '../../../models/additional-esocket-config-view-model';
import { TerminalProfilesViewModel } from '../../../models/terminal-profiles-view-model';
import { PropertyProfileViewModel } from '../../../models/property-profile-view-model';
import { ConfirmationDialogComponent } from '../../../partials/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'app-e-socket-config',
  templateUrl: './e-socket-config.component.html',
  styleUrls: ['./e-socket-config.component.scss']
})
export class ESocketConfigComponent implements OnInit {
  public retailerForm: FormGroup;
  public storeForm: FormGroup;
  public configSetForm: FormGroup;
  public rolloutGroupForm: FormGroup;
  public LaneProfilesForm: FormGroup;
  public AdditionalConfigForm: FormGroup;
  public TerminalProfilesForm: FormGroup;

  public submittedRetailer: boolean;
  public submittedConfigSet: boolean;
  public submittedStore: boolean;
  public submittedRolloutGroup: boolean;
  public submittedLaneProfilesForm: boolean;
  public submittedAdditionalConfigForm: boolean;
  public submittedTerminalProfilesForm: boolean;

  public retailerViewModel: RetailerConfigViewModel;
  public configSetViewModel: ConfigSetViewModel;
  public propertyProfileViewModel: PropertyProfileViewModel;

  public createResult: CreateResult;
  public raiseDanger: boolean;
  private _destroyed$ = new Subject<any>();
  public id: number = 0;
  public isNew: boolean;
  public participantId: number;
  public ConfigSetItems: Select2OptionData[];
  public rolloutGroupItems: Select2OptionData[];
  public regionCodeItems: Select2OptionData[];
  public countryCodeItems: Select2OptionData[];
  public branchItems: Select2OptionData[];
  public terminalProfileItems: Select2OptionData[];
  public aidClassItems: Select2OptionData[];
  public storesItems: Select2OptionData[];
  public merchantTypes: Select2OptionData[];
  public cardSets: Select2OptionData[];
  public retailer: RetailerConfigViewModel;
  public multipleStores: boolean = false;
  public newRetailer: boolean = false;
  public getStores: StoreViewModel[] = [];
  public getLaneProfiles: LaneProfilesViewModel[] = [];
  public get useLogin(): Select2OptionData[] {
    const items = [
      { id: "dbo", text: 'dbo' },
      { id: "esp_cfg", text: 'esp_cfg' }
    ];
    return items;
  }
  public get YesNoOptions(): Select2OptionData[] {
    const items = [
      { id: "true", text: 'True' },
      { id: "false", text: 'False' }
    ];
    return items;
  }

  public get TrueFalseOptions(): Select2OptionData[] {
    const items = [
      { id: '1', text: 'True' },
      { id: '0', text: 'False' }
    ];
    return items;
  }
  public select2options: any = {
    multiple: false,
    width: '100%'
  };

  constructor(
    private _participantService: ParticipantService,
    private _toastService: ToastrService,
    private _userDataStore: UserDataStoreService,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _modalService: NgbModal,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _terminalConfigService: TerminalConfigService,
    private _merchantService: MerchantService,
    private _route: ActivatedRoute
  ) {
    this.participantId = _userDataStore.selectedParticipant.id;

    _route.params.pipe(takeUntil(this._destroyed$)).subscribe(async params => {
      if (params.id != 'new') {
        this.id = params.id;
      }
      else {
        this.isNew = true;
        this._toastService.error('Save the terminal configuration prior to completing the esocket configuration.', "Error");
        this.raiseDanger = true;
      }
    });
  }

  async ngOnInit() {
    debugger;
    this.retailerForm = this._formBuilder.group({
      retailerId: ['', [Validators.required]],
      name: ['', [Validators.required]],
      participantId: [this.participantId],
      terminalConfigId: this.id
    });

    this.storeForm = this._formBuilder.group({
      storeId: ['', [Validators.required]],
      retailerId: [this.retailer?.retailerId, [Validators.required]]
    });

    this.configSetForm = this._formBuilder.group({
      retailerId: ['', [Validators.required]],
      configIdSuffix: ['', [Validators.required]]
    });

    this.LaneProfilesForm = this._formBuilder.group({
      retailerId: ['', [Validators.required]],
      laneProfile: ['', [Validators.required]],

    });


    this.AdditionalConfigForm = this._formBuilder.group({
      commandPort: ['50051'],
      connType: ['MagicR', [Validators.required]],
      rank: [0, [Validators.required]],
      sapAddress: ['172.16.3.58'],
      customData: [''],
      participantId: [this.participantId],
      terminalConfigId: [this.id]
    });

    if (this.isNew == true) {

      Object.keys(this.storeForm.controls).forEach(key => {
        this.storeForm.controls[key].disable();
      });

      Object.keys(this.configSetForm.controls).forEach(key => {
        this.configSetForm.controls[key].disable();
      });

      Object.keys(this.LaneProfilesForm.controls).forEach(key => {
        this.LaneProfilesForm.controls[key].disable();
      });

      Object.keys(this.AdditionalConfigForm.controls).forEach(key => {
        this.AdditionalConfigForm.controls[key].disable();
      });

      Object.keys(this.TerminalProfilesForm.controls).forEach(key => {
        this.TerminalProfilesForm.controls[key].disable();
      });
    }

    const getRetailer = await this._terminalConfigService.GetRetailer(this.participantId, this.id);
    if (getRetailer != null) {
      this.configSetForm.controls["retailerId"].setValue(getRetailer.retailerId);
      this.storeForm.controls["retailerId"].setValue(getRetailer.retailerId);

      this.getStores = await this._terminalConfigService.GetStoreByRetailerId(getRetailer.retailerId);
      this.getLaneProfiles = await this._terminalConfigService.GetLaneProfilesByRetailer(getRetailer.retailerId);

      this.retailerViewModel = getRetailer;

    }
    else {
      this.newRetailer = true;
    }
  }

  public async initTable(selectedIndex: number): Promise<void> {
    await this._loadTabData(selectedIndex);
  }

  private async _loadTabData(index: number): Promise<void> {
    this._ngxUiLoaderService.start();
    switch (index) {

      case 1:
        //Retailer
        if (this.id > 0) {
          this.retailerViewModel = await this._terminalConfigService.GetRetailer(this.participantId, this.id);
          if (this.retailerViewModel != null) {
            this.retailerForm.patchValue(this.retailerViewModel);
            this.retailerForm.controls['retailerId'].disable();
          }
          else {
            this.newRetailer = true;
          }
        }
        break;

      case 2:
        //Configset
        debugger;
        if (this.id > 0) {
          const getRetailer = await this._terminalConfigService.GetRetailer(this.participantId, this.id);
          if (getRetailer != null) {
            this.configSetForm.controls["retailerId"].setValue(getRetailer.retailerId);

            this.configSetViewModel = await this._terminalConfigService.GetConfigIdSuffix(getRetailer.retailerId);
            if (this.configSetViewModel != null) {
              this.configSetForm.patchValue(this.configSetViewModel);
              this.configSetForm.controls["configIdSuffix"].disable();
              this.configSetForm.controls["configIdSuffix"].setValue(this.configSetViewModel.configIdSuffix);
            }
          }
        }
        break;

      case 3:
        //Store
        if (this.id > 0) {
          debugger;
          const getRetailer = await this._terminalConfigService.GetRetailer(this.participantId, this.id);
          if (getRetailer != null) {
            this.storeForm.controls["retailerId"].setValue(getRetailer.retailerId);
            debugger;
            const getStores = await this._terminalConfigService.GetStoreByRetailerId(getRetailer.retailerId);
            if (getStores?.length > 0) {
              if (getStores?.length > 1) {
                this.multipleStores = true;
              }
              this.storesItems = (getStores).map((x) => {
                return { id: x.storeId, text: x.storeId }
              });

              this.storeForm.patchValue(getStores[0]);
            }
          }
        }

        break;

      case 4:
        //Lane profile
        if (this.id > 0) {
          const getRetailer = await this._terminalConfigService.GetRetailer(this.participantId, this.id);
          if (getRetailer != null) {
            this.LaneProfilesForm.controls["retailerId"].setValue(getRetailer.retailerId);
            const getLaneProfile = await this._terminalConfigService.GetLaneProfilesByRetailer(getRetailer.retailerId);

            this.getLaneProfiles = getLaneProfile;
            if (getLaneProfile != null) {
              this.LaneProfilesForm.patchValue(getLaneProfile);
              this.LaneProfilesForm.controls["laneProfile"].setValue(getLaneProfile[0].laneProfile);
            }
          }
        }
        break;

      case 5:
        //Additional config set
        if (this.id > 0) {
          const getAdditionalConfig = await this._terminalConfigService.GetAdditionalEsocketConfig(this.participantId, this.id);
          if (getAdditionalConfig != null) {
            this.AdditionalConfigForm.patchValue(getAdditionalConfig);
          }
        }
        break;

      default:
        if (this.id > 0) {
          this.retailerViewModel = await this._terminalConfigService.GetRetailer(this.participantId, this.id);
          if (this.retailerViewModel != null) {
            this.retailerForm.patchValue(this.retailerViewModel);
            this.retailerForm.controls['retailerId'].disable();
          }
          else {
            this.newRetailer = true;
          }
        }
        break;
    }
    this._ngxUiLoaderService.stop();
  }

  formatDateToInputValue(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  }

  private async importRetailer(): Promise<void> {
    if (this.retailerForm.controls["retailerId"].value == '') {
      this._toastService.error('Retailer Id is required.', "Error");
      this.raiseDanger = true;
      return;
    }

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Link retailer to this participant"
    dialogRef.componentInstance.message = "Are you sure you want to link the selected Retailer to this participant?"

    const result = await dialogRef.result;
    if (result) {
      //await this.deleteMerchant(merchant);
      var retailerViewModel: RetailerConfigViewModel = {
        retailerId: this.retailerForm.controls["retailerId"].value,
        name: this.retailerForm.controls["retailerId"].value,
        participantId: this.participantId,
        terminalConfigId: this.id,
        laneProfile: null,
        terminalProfile: null
      };


      this.createResult = await this._terminalConfigService.SyncRetailer(retailerViewModel);

      if (this.createResult.success === true) {
        this._toastService.success(this.createResult.message, "Success");
        this.raiseDanger = false;
      } else {
        this._toastService.error(this.createResult.message, "Error");
        this.raiseDanger = true;
      }
    }
  }

  private async saveUpdateRetailer(): Promise<void> {
    debugger;
    this.submittedRetailer = true;
    if (!this.retailerForm.valid) {
      this._toastService.error("All required fields must be filled", "Error");
      this.raiseDanger = true;
      return;
    }
    this._ngxUiLoaderService.start();

    var retailerViewModel: RetailerConfigViewModel;
    if (this.retailerViewModel != null) {
      retailerViewModel = this.retailerViewModel;
      retailerViewModel.name = this.retailerForm.controls["name"].value;
    } else {
      retailerViewModel = this.retailerForm.value;
    }
    this.raiseDanger = true;
    if (this.retailerViewModel == null) {
      this.createResult = await this._terminalConfigService.CreateRetailer(retailerViewModel);
    }
    else {
      this.createResult = await this._terminalConfigService.UpdateRetailer(retailerViewModel);
    }

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();
  }

  private async SyncConfigSet(): Promise<void> {
    this.submittedConfigSet = true;
    debugger;
    if (!this.configSetForm.valid) {
      this._toastService.error("All mandatory fields must be filled", "Error");
      this.raiseDanger = true;
      return;
    }
    this._ngxUiLoaderService.start();

    var configSetViewModel: ConfigSetViewModel = this.configSetForm.value;
    configSetViewModel.configIdSuffix = this.configSetForm.controls['configIdSuffix'].value;
    this.raiseDanger = true;
    this.createResult = await this._terminalConfigService.SyncConfigSet(configSetViewModel);

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();

  }

  private async SyncStore(): Promise<void> {
    debugger;
    this.submittedStore = true;

    if (!this.storeForm.valid) {
      return;
    }
    this._ngxUiLoaderService.start();

    const storeViewModel: StoreViewModel = this.storeForm.value;
    storeViewModel.retailerId = this.storeForm.controls["retailerId"].value;
    storeViewModel.storeId = this.storeForm.controls["storeId"].value;

    this.raiseDanger = true;
    this.createResult = await this._terminalConfigService.SyncStore(storeViewModel);

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.getStores = await this._terminalConfigService.GetStoreByRetailerId(storeViewModel.retailerId);
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();

  }

  private async saveUpdateRolloutGroup(): Promise<void> {
    debugger;
    this.submittedRolloutGroup = true;


    if (!this.rolloutGroupForm.valid) {
      return;
    }
    this._ngxUiLoaderService.start();

    const rolloutGroupViewModel: RolloutGroupViewModel = this.rolloutGroupForm.value;

    this.raiseDanger = true;
    this.createResult = await this._terminalConfigService.CreateRollOutGroup(rolloutGroupViewModel);

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();

  }

  private async SyncLaneProfile(): Promise<void> {
    this.submittedLaneProfilesForm = true;
    debugger;
    if (!this.LaneProfilesForm.valid) {
      return;
    }

    this._ngxUiLoaderService.start();

    const laneProfileViewModel: LaneProfilesViewModel = this.LaneProfilesForm.value;
    laneProfileViewModel.laneProfile = this.LaneProfilesForm.controls['laneProfile'].value;
    laneProfileViewModel.retailerId = this.retailerForm.controls["retailer_id"]?.value ?? this.retailerViewModel.retailerId;

    this.raiseDanger = true;
    this.createResult = await this._terminalConfigService.SyncLaneProfile(laneProfileViewModel);

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.getLaneProfiles = await this._terminalConfigService.GetLaneProfilesByRetailer(laneProfileViewModel.retailerId);
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();

  }

  private async saveUpdateTerminalProfiles(): Promise<void> {
    this.submittedTerminalProfilesForm = true;
    debugger;
    if (!this.TerminalProfilesForm.valid) {
      return;
    }

    this._ngxUiLoaderService.start();

    const terminalProfilesViewModel: TerminalProfilesViewModel = this.TerminalProfilesForm.value;
    terminalProfilesViewModel.termProf = this.TerminalProfilesForm.controls["termProf"].value;

    this.raiseDanger = true;
    this.createResult = await this._terminalConfigService.CreateUpdateTerminalProfiles(terminalProfilesViewModel, this.retailerForm.controls['retailerId'].value);

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();

  }

  private async saveUpdateAdditionalConfig(): Promise<void> {
    this.submittedAdditionalConfigForm = true;
    debugger;
    if (!this.AdditionalConfigForm.valid) {
      return;
    }

    this._ngxUiLoaderService.start();

    const AdditionalEsocketConfigViewModel: AdditionalEsocketConfig = this.AdditionalConfigForm.value;

    this.raiseDanger = true;
    this.createResult = await this._terminalConfigService.CreateUpdateAdditionalEsocketConfig(AdditionalEsocketConfigViewModel);

    if (this.createResult.success === true) {
      this._toastService.success(this.createResult.message, "Success");
      this.raiseDanger = false;
    } else {
      this._toastService.error(this.createResult.message, "Error");
      this.raiseDanger = true;
    }

    this._ngxUiLoaderService.stop();

  }

  public async setStore(event: string): Promise<void> {
    this._ngxUiLoaderService.start();
    const getStore = await this._terminalConfigService.GetStore(event);
    if (getStore != null) {
      this.storeForm.patchValue(getStore);
    }

    this._ngxUiLoaderService.stop();
  }

  public async deleteStore(store: StoreViewModel) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Unlink Store"
    dialogRef.componentInstance.message = "Are you sure you want to remove the selected store?"

    const result = await dialogRef.result;
    debugger;
    if (result) {
      this.createResult = await this._terminalConfigService.DeleteStore(store);
      if (this.createResult.success == true) {
        this.getStores = await this._terminalConfigService.GetStoreByRetailerId(store.retailerId);
        this._toastService.success(this.createResult.message, "Success");  
      }
      else {
        this._toastService.error(this.createResult.message, "Error");
      }
    }

  }

  public async deleteLaneProfile(laneProfile: LaneProfilesViewModel) {

    const dialogRef = this._modalService.open(ConfirmationDialogComponent, {
      windowClass: 'modal-fade-in',
      centered: false,
      size: 'xl',
      backdrop: 'static'
    });
    dialogRef.componentInstance.showCancel = true;
    dialogRef.componentInstance.acceptButtonText = "Yes";
    dialogRef.componentInstance.cancelButtonText = "No"
    dialogRef.componentInstance.title = "Unlink Lane profile"
    dialogRef.componentInstance.message = "Are you sure you want to remove the selected lane profile?"

    const result = await dialogRef.result;
    debugger;
    if (result) {
      this.createResult = await this._terminalConfigService.DeleteLaneProfile(laneProfile);
      if (this.createResult.success == true) {
        this.getLaneProfiles = await this._terminalConfigService.GetLaneProfilesByRetailer(laneProfile.retailerId);
        this._toastService.success(this.createResult.message, "Success");
      }
      else {
        this._toastService.error(this.createResult.message, "Error");
      }
    }
  }
}


